import { inject, injectable } from 'inversify';
import * as FileSaver from "file-saver";

import { HttpService } from "src/core/services/http.service";

@injectable()
export class DocumentService {
	@inject(HttpService)
	private httpService: HttpService;

	private baseUrl = 'api/v1/documents';

	public downloadDocument(containerId: string, id: number, filename: string) {
		return this.httpService.get(`${this.baseUrl}/file/download/${containerId}/${id}`, { responseType: "blob" })
			.then(res => {
				const blob = res.data;
				FileSaver.saveAs(blob, filename);
			});
	}

	public downloadTemplate(record: IDocumentTemplateSummary) {
		this.httpService.get(`${this.baseUrl}/template/download/${record.id}`, { responseType: "blob" })
			.then(res => {
				const blob = res.data;
				FileSaver.saveAs(blob, record.displayName + ".rdl");
			});
	}

	public generate(targetId: number, usage: string, templateId: number, format: string, exportLanguage: string) {
		return this.httpService.post(`${this.baseUrl}/template/generate`, {
			targetId,
			usage,
			templateId,
			format,
			exportLanguage
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/shared/document.service.ts